exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".body{background-color:#eee;margin-top:100px}.icono{margin:auto;width:60%;padding:10px;width:180px;line-height:180px;text-align:center}.form-actions{margin:0;background-color:transparent;text-align:center}.boton{color:#fff}.bn{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4212dc2a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/login.vue
// module id = 391
// module chunks = 0